import {AuthState} from '>root/store/reducers/authReducer';

export function isValidAuthState(authState: AuthState) {
  return authState.isValidToken && authState.isAuthenticated && Boolean(authState.token?.user);
}
